import React, { useEffect, useState, useRef } from "react";
import ReactPaginate from "react-paginate";
import { Helmet } from "react-helmet";

// import Header from "../components/Header/Header";
import NewHeader from "../components/NewHeader/NewHeader";
import TopNav from "../components/TopNav/TopNav";
import ScrolltoTop from "../components/Scrolltotop/ScrolltoTop";
import Footer from "../components/Footer/Footer";
import SubFooter from "../components/SubFooter/SubFooter";
import { useSelector, useDispatch } from "react-redux";
import useForm from "./useForm";
import validate from "./validation";
import moment from "moment";

//importing banner images from folder
// import banner from "../../../Assets/slider/mainbanner1.webp";
// import banner from "../Assets/newAsset/career/careerDesktop.png";
// import Mobilebanner from "../Assets/newAsset/career/careerMobile.png";
import CareerIcon1 from "../Assets/newAsset/career/careerIcon1.svg";
import CareerIcon2 from "../Assets/newAsset/career/careerIcon2.svg";
import CareerIcon3 from "../Assets/newAsset/career/careerIcon3.svg";

import { Modal } from "react-responsive-modal";

import { FiChevronDown } from "react-icons/fi";
import { RiArrowUpSLine } from "react-icons/ri";

import CareerRight from "../Assets/newAsset/career/careerRight.png";
import miniLogo from "../Assets/newAsset/career/minilogo.jpg";

import { Scroll } from "../components/Scroll function/scroll";
import "./Career.css";

// import { careerFormSubmit, getJobData } from "../Redux/Actions";
import { ImStarEmpty } from "react-icons/im";
import {
  careerFormSubmit,
  getJobData,
  paginationAction,
  careerPagination,
  getCareerData,
  getJobPostingCareerData
} from "../Redux/Actions";
import { json } from "express";
import { array, string } from "prop-types";
import { stringify } from "qs";
import { connect } from "react-redux";

const content = [
  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diamnonumy eirmod tempor invidunt ut labore et dolore magna aliquyamerat, sed diam voluptua. At vero eos et accusam et justo duo doloreset ea rebum. Stet clita kasd gubergren, no sea takimata sanctus estLorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetursadipscing elitr, sed diam nonumy eirmod tempor invidunt ut laboreet dolore magna aliquyam erat, sed diam voluptua. At vero eos etaccusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,no sea takimata sanctus est Lorem ipsum dolor sit amet.",
];

export const Onecomponent = ({ title, content, para }) => {
  return (
    <div className="buildTogether">
      <div className="buildTogether_content">
        <h2>{title}</h2>
        <p>{content}</p>
        <p>{para}</p>
      </div>
    </div>
  );
};
function Career(props) {
  const [loader, setLoader] = useState(true);
  const jobsData = useSelector((state) => state.jobs);
  const { jobs, loading } = jobsData;
  const formRef = useRef();

  /// jobs?.map((value)=>{
  //   console.log("id",value.id)
  // })
  //CONST IMPORT FORM
  // const { handleChange, handleSubmit, values, errors, isSubmitting } =
  //   useForm();

  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const [base64File, setbase64File] = useState("");

  const paginatedDataStore = useSelector((state) => state.paginationReducer);
  const collectionData = useSelector((state) => state.collectionCenter);

  const careerPaginationStore = useSelector(
    (state) => state.careerpaginationReducer
  );

  const { loading: careerpaginationLoading } = careerPaginationStore;
  // const { loading: paginationLoading } = paginatedDataStore;

  const [CareerpaginationData, setCareerpagination] = useState("");

  const [careerData, setCareerData] = useState(null);
  const [careerJobPostingData, setCareerJobPostingData] = useState([]);
  useEffect(() => {
    props.getCareerData();
    props.getJobPostingCareerData()
  }, []);

  useEffect(() => {
    setCareerData(props.careerData);
    setCareerJobPostingData(props?.careerjobPostingList)
  }, [props.careerData]);

  //data from useForm customHoock
  //console.log("data from custom hook", isSubmitting);
  useEffect(() => {
    Scroll();
  }, []);

  // useEffect(() => {}, [isSubmitting]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!jobsData.loading) {
      // console.log("store data", collectionData);
      setCareerpagination(jobsData.jobs);
      setLoader(false);
    } else {
      // console.log("store data", collectionData.collection);
      setLoader(true);
    }
  }, [jobsData]);

  useEffect(() => {
    if (!careerpaginationLoading) {
      setCareerpagination(careerPaginationStore.paginated);
    }
  }, [careerpaginationLoading, CareerpaginationData]);

  // // //getting jobs data
  // useEffect(() => {
  //   dispatch(getJobData());
  //   if (loading) {
  //     setLoader(true);

  //   } else {
  //     setLoader(false);

  //   }

  // }, []);
  // console.log("jobsdata",loading?"loading": jobsData);
  // console.log("jobsdata Result",loading?"loading": jobsData.jobs.results);

  //form textField area  setfullName setemail setjobProfile setexperience setcompany setdesignation setperiod setaddress
  const [fullname, setfullName] = useState("");
  const [NameError, setNameError] = useState("");
  const [EmailError, setEmailError] = useState("");

  const [email, setemail] = useState();
  const [filerequired, setFilerequired] = useState(false);

  const [jobProfile, setjobProfile] = useState();

  const [experience, setexperience] = useState();
  const [experienceError, setexperienceError] = useState("");

  const [company, setcompany] = useState();
  const [companyError, setCompanyError] = useState("");

  const [designation, setdesignation] = useState();
  const [DesignationError, setDesignationError] = useState("");

  const [period, setperiod] = useState();
  const [periodError, setPeriodError] = useState("");

  const [address, setaddress] = useState("");
  const [jobPostingId, setJobPostingId] = useState("")
  const [successMsg, setSuccessMsg] = useState(false);

  //DISABLE STATE
  const [disable, setdisable] = useState(false);

  const [showDiv, setShowDiv] = useState(false);
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const [NewErrors, setErrors] = useState({});
  //Handel form validation

  //handel center data pagination
  const handlePageClick = (data) => {
    Scroll();
    let cuurrpage = data.selected + 1;
    dispatch(careerPagination(cuurrpage));
  };

  //handelNameValidaation
  const handelName = (e) => {
    setfullName(e.target.value);
    if (!/^[A-Za-z ]+$/.test(e.target.value.trim())) {
      setNameError("Enter a valid name");
    } else {
      setNameError("");
    }
    if (e.target.value == "") {
      setNameError("");
    }
  };
  const handleEmail = (e) => {
    setemail(e.target.value);
    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        e.target.value.trim()
      )
    ) {
      setEmailError("Enter a valid email");
    } else {
      setEmailError("");
    }
    if (e.target.value == "") {
      setEmailError("");
    }
  };
  //handelExperience
  const HandelExperience = (e) => {
    setexperience(e.target.value);
    if (/^[A-Za-z ]+$/.test(e.target.value.trim())) {
      setexperienceError("Enter  experience in numbers");
    } else {
      setexperienceError("");
    }
  };

  //Handel company error
  const handelCompanyError = (e) => {
    setcompany(e.target.value);
    if (!/^[A-Za-z ]+$/.test(e.target.value.trim())) {
      setCompanyError("Enter valid organization");
    } else {
      setCompanyError("");
    }
  };

  //handel designation change
  const handelDesignation = (e) => {
    setdesignation(e.target.value);
    if (!/^[A-Za-z ]+$/.test(e.target.value.trim())) {
      setDesignationError("Enter valid designation");
    } else {
      setDesignationError("");
    }
  };

  //const Disable BUtoon
  useEffect(() => {
    if (
      NameError !== "" ||
      EmailError !== "" ||
      DesignationError !== "" ||
      periodError !== "" ||
      companyError !== "" ||
      fileError !== "" ||
      experienceError !== "" ||
      base64File == ""
    ) {
      setdisable(true);
    } else {
      setdisable(false);
    }
  }, [
    NameError,
    EmailError,
    DesignationError,
    periodError,
    companyError,
    fileError,
    experienceError,
    base64File,
  ]);

  //HANDEL notice period
  const handelNotice = (e) => {
    setperiod(e.target.value);
    if (/^[A-Za-z ]+$/.test(e.target.value.trim())) {
      setPeriodError("Enter  period in numbers");
    } else {
      setPeriodError("");
    }
  };
  //changefilein base 64 string
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  console.log(props?.careerjobPostingList, "<<<<<<")

  //const handelFILECHNAGE
  const handelFilechange = (e) => {
    setFileName(e.target.files[0].name);
    // Allowing file type
    const filePath = e.target.value;
    //Doc, Docx and PDF
    console.log(filePath);
    var allowedExtensions = /(\.doc|\.pdf|\.docx)$/i;
    if (allowedExtensions.exec(filePath)) {
      setFileName(e.target.files[0].name);
      setFileError("");
      var file = e.target.files[0];
      getBase64(file).then((data) => {
        setbase64File(data);
        console.log(data);
      });
    } else {
      setFileName("");
      setFileError("invalid file type");
    }
    e.target.value = "";
  };

  //handel career form
  // const handelCareerSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("form submit", formBody);
  //   dispatch(formBody);
  //   setSuccessMsg(true);
  //   setTimeout(() => {
  //     setSuccessMsg(false);
  //   }, 2000);
  // };

  //handelSubmit
  const handleSubmit = (e) => {
    e.preventDefault();
    const formBody = {
      job_posting:jobPostingId,
      name: fullname,
      email: email,
      job_profile: jobProfile,
      experience: experience,
      current_organization: company,
      current_designation: designation,
      notice_periods: period,
      address,
      cv: base64File,
    };

    dispatch(careerFormSubmit(formBody));

    setfullName("");
    setemail("");
    setjobProfile("");
    setexperience("");
    setcompany("");
    setdesignation("");
    setperiod("");
    setaddress("");
    setbase64File("");
    setFileName("");
    setSuccessMsg(true);
    setTimeout(() => {
      setSuccessMsg(false);
    }, 2000);
  };

  const [viewMore, setViewMore] = useState([]);

  const handleViewMore = (i) => {
    setViewMore([...viewMore, i]);
  };
  const handleViewLess = (i) => {
    setViewMore(
      viewMore.filter((x) => {
        return x != i;
      })
    );
    console.log(viewMore, i, "vm");
  };

  return (
    <div className="career">
      <Helmet>
        <title>
          Career – Life and Opportunities @ Redcliffe Labs, Job Openings
        </title>
        <meta
          name="description"
          content="Redcliffe Labs is a great place to work for. Life at Redcliffe is really interesting. Check Opportunities, talent acquisition and job openings at Redcliffe Labs"
        />
      </Helmet>
      {/* <TopNav /> */}
      <NewHeader />

      {/** Main content startss here */}

      <div className="career_banner">
        <img
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/9febfcdf-9f3a-4d1e-9925-d226a5bcc854.png"
          alt="baneer"
          className="CarrerDesktop_44"
        />
        <img
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/4b287af4-93fe-4998-bd24-21efa787df8c.png"
          alt="MobileBanner"
          className="CarrerMobile_44"
        />
      </div>
      <Onecomponent
        title="Build together, grow together"
        content={
          "Started as a flourishing start-up, Redcliffe Labs has become a team of 1000+ talented professionals with a mission to present a market space that enables you to help people get the right advice for their health. At Redcliffe Labs, we work hard to get candidates interested in our domains and work culture. We galvanize the employees to become a part of our brand to grow with us. We hire on purpose. What’s yours?"
        }
      />

      <div className="lifeRedclifee">
        <div className="lifeRedclifee__leftSide careersRedLifeDescHead">
          <h2>Life @ Redcliffe</h2>
          <div className="lifeRedclifee__leftSide__content careersRedLifeDesc">
            <p className="paraWidth">
              Every employee is a valuable part of the Redcliffe family, and we
              celebrate the success of every employee and management staff with
              the same level of gusto. The company is home to more than 1000+
              loyal and passionate team members, and the employees are endlessly
              working towards a common goal. The accomplishment of one project
              is the victory of a communal team that makes the brand prominent
              around the globe.
            </p>
            <p className="paraWidth">
              At Redcliffe Labs, every team member has one thing in common:
              their dedication to work and offering unrivaled solutions in the
              field of healthcare. We’re thrilled to announce exemplary job
              openings at Redcliffe Labs to bring more industry-driven work to
              leading brands. The entire team of Redcliffe Labs together is
              accountable for the success of the company. We are known for our
              dedication to work to stay one step ahead of the curve.
            </p>
          </div>
        </div>
        <div className="lifeRedclifee__rightSide careerImagesLifered">
          <img src={CareerRight} className="rightMain" alt="right-side-img" />
          <img
            src={miniLogo}
            alt=""
            className="rightMinImg careerImagesLifered2"
          />
        </div>
      </div>
      <Onecomponent
        title="Opportunities @ Redcliffe"
        content={
          "The journey to becoming the best is not a cakewalk, but the company sets weekly goals that the team celebrates achieving. Every day the management at Redcliffe Labs comes up with unique ways to make their employees’ days more joyful and productive. When it comes to growth, Redcliffe Labs offers limitless opportunities to its employees. Whether it is about enhancing skills or getting rewarded for good work, its goal is to grow together."
        }
      />
      {/* {loading? "loader" : jobsData?.jobs?.results?.map((val,ind)=>(<span >{val.salary}</span>))} */}
      {careerData?.career_data?.results ? (
        <div className="currentOpeningsHeading">
          <h2> Current Job Openings</h2>
        </div>
      ) : null}
      {careerData?.loading
        ? "loading"
        : careerData?.career_data?.results?.map((val, index) => (
          <div className="currentOpeningsMainDiv" key={index} value={val.id}>
            <div className="currentOpeningsDiv">
              {val?.job_description != "" ? (
                <div
                  className={
                    viewMore.includes(index)
                      ? " currentOpeningsDivLess"
                      : "currentOpeningsDivMore"
                  }
                >
                  <div className="jobDiv">
                    <div className="jobLeftDiv">
                      <h2> {val.headline}</h2>
                      <div className="jobDetailsDiv">
                        <div className="jobDetails">
                          <img
                            src={CareerIcon1}
                            alt="Icons"
                            className="careerIcons"
                          />{" "}
                          {val.work_from_home ? (
                            <p>Work From Home</p>
                          ) : (
                            <p>{val?.location || " Sector 63, Electronic City, Noida"}</p>
                          )}
                        </div>
                        <div className="jobDetails">
                          <img
                            src={CareerIcon2}
                            alt="Icons"
                            className="careerIcons"
                          />{" "}
                          <p>
                            {val.min_work_exp} - {val.max_work_exp} Years
                            Experience{" "}
                          </p>
                        </div>
                        {/* <div className="jobDetails">
                            <img
                              src={CareerIcon3}
                              alt="Icons"
                              className="careerIcons"
                            />{" "}
                            {val.min_annual_salary ? (
                              <p>
                                INR {val.min_annual_salary} -{" "}
                                {val.max_annual_salary}
                              </p>
                            ) : (
                              <p> Not Disclosed</p>
                            )}
                          </div> */}
                      </div>
                    </div>
                    <div className="jobRightDiv">
                      <button onClick={() => {
                        setJobPostingId(val?.id)
                        onOpenModal()
                      }}>
                        Apply For This Job
                      </button>
                      <Modal
                        classNames={{
                          overlay: "careerPageModalOverlay",
                          modal: "careerPageModal",
                        }}
                        open={open}
                        onClose={onCloseModal}
                        center
                      >
                        <div className="workWithUs">
                          <h2>Work with us</h2>
                          <p>
                            Fill in your details and know about the current
                            job openings.
                          </p>
                        </div>
                        <div className="formDiv">
                          <form
                            onSubmit={handleSubmit}
                            id="create-course-form"
                          >
                            <div className="forPartition">
                              <div className="formDiv__left">
                                <div className="inputField">
                                  <div className="errorDIV">
                                    <label>Your Full Name*</label>{" "}
                                    {NameError !== "" ? (
                                      <span className="careerError">
                                        {NameError}
                                      </span>
                                    ) : null}
                                  </div>

                                  <input
                                    type="text"
                                    className={
                                      NameError !== "" ? "errorOccur" : null
                                    }
                                    value={fullname}
                                    onChange={handelName}
                                    required
                                    placeholder="Enter Your Full Name"
                                  />
                                </div>
                                <div className="inputField">
                                  <div className="errorDIV">
                                    <label>Your Email Address*</label>
                                    {EmailError !== "" ? (
                                      <span className="careerError">
                                        {EmailError}
                                      </span>
                                    ) : null}
                                  </div>
                                  <input
                                    type="email"
                                    required
                                    value={email}
                                    className={
                                      EmailError !== "" ? "errorOccur" : null
                                    }
                                    onChange={handleEmail}
                                    placeholder="Enter Your Email Address"
                                  />
                                </div>

                                <div className="inputField">
                                  <label>Select Job Profile*</label>
                                  <select
                                    required
                                    value={jobProfile}
                                    onChange={(e) =>
                                      setjobProfile(e.target.value)
                                    }
                                  >
                                    <option value="" disabled selected>
                                      Select Job Profile
                                    </option>
                                    {loader
                                      ? "loading"
                                      : careerJobPostingData?.map(
                                        (val, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={val?.id}
                                            >
                                              {val?.area}
                                            </option>
                                          )
                                        }
                                      )}
                                  </select>
                                </div>
                                <div className="inputField">
                                  <div className="errorDIV">
                                    <label>
                                      Total Experience (in Years)*
                                    </label>

                                    {experienceError !== "" ? (
                                      <span className="careerError">
                                        {experienceError}
                                      </span>
                                    ) : null}
                                  </div>
                                  <input
                                    type="text"
                                    value={experience}
                                    onChange={HandelExperience}
                                    required
                                    placeholder="Enter Your Total Experience (in Years)"
                                  />
                                </div>
                                <div className="inputField">
                                  <div className="errorDIV">
                                    <label>Current Organization*</label>

                                    {companyError !== "" ? (
                                      <span className="careerError">
                                        {companyError}
                                      </span>
                                    ) : null}
                                  </div>
                                  <input
                                    type="text"
                                    className={
                                      companyError !== ""
                                        ? "errorOccur"
                                        : null
                                    }
                                    value={company}
                                    onChange={handelCompanyError}
                                    required
                                    placeholder="Enter Your Current Organization"
                                  />
                                </div>
                              </div>
                              <div className="formDiv__right">
                                <div className="inputField">
                                  <div className="errorDIV">
                                    <label>Current Designation*</label>

                                    {DesignationError !== "" ? (
                                      <span className="careerError">
                                        {DesignationError}
                                      </span>
                                    ) : null}
                                  </div>
                                  <input
                                    className={
                                      DesignationError !== ""
                                        ? "errorOccur"
                                        : null
                                    }
                                    type="text"
                                    required
                                    value={designation}
                                    onChange={handelDesignation}
                                    placeholder="Enter Your Current Designation"
                                  />
                                </div>
                                <div className="inputField">
                                  <div className="errorDIV">
                                    <label>Notice Period (in Months)*</label>
                                    {periodError !== "" ? (
                                      <span className="careerError">
                                        {periodError}
                                      </span>
                                    ) : null}
                                  </div>
                                  <input
                                    className={
                                      periodError !== "" ? "errorOccur" : null
                                    }
                                    type="text"
                                    required
                                    value={period}
                                    onChange={handelNotice}
                                    placeholder="Enter Notice Period"
                                  />
                                </div>
                                <div className="inputField">
                                  <label>Address</label>

                                  <textarea
                                    rows="3"
                                    onChange={(e) =>
                                      setaddress(e.target.value)
                                    }
                                    cols="50"
                                    placeholder="Enter Your Address"
                                    value={address}
                                  ></textarea>
                                </div>
                                <div className="inputField">
                                  <label>
                                    Upload CV (Doc, Docx and PDF format only)
                                  </label>

                                  <div className="uploadDiv">
                                    <label
                                      htmlFor="uploadLabel"
                                      className="uploadLabel"
                                    >
                                      Choose File
                                    </label>
                                    <input
                                      id="uploadLabel"
                                      className="uploadFile"
                                      ref={formRef}
                                      onChange={handelFilechange}
                                      hidden
                                      required
                                      type="file"
                                    />
                                    <span id="file-chosen">
                                      {fileError ? (
                                        <span className="careerError">
                                          {fileError}
                                        </span>
                                      ) : fileName ? (
                                        <span>{fileName}</span>
                                      ) : (
                                        "No file chosen"
                                      )}
                                    </span>
                                  </div>
                                  {filerequired ? (
                                    <span className="careerError">
                                      "please upload CV"
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="successDiv">
                              <p className="success">
                                {successMsg
                                  ? "Your form has been submitted successfully"
                                  : null}
                              </p>
                            </div>
                            <div className="subMitDiv">
                              <button
                                type="submit"
                                disabled={disable ? "disabled" : ""}
                                className={
                                  disable
                                    ? "submitButton disableButton"
                                    : "submitButton"
                                }
                                onClick={handleSubmit}
                              >
                                SUBMIT
                              </button>
                            </div>
                          </form>
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div className="jobDetails2Div">
                    <div className="Details2box">
                      <p className="jobPara1">Posted on: </p>
                      <p className="jobPara2">
                        {moment(val.created_at).format("Do MMM  YYYY")}
                      </p>
                    </div>
                    <div className="Details2box">
                      <p className="jobPara1">Vacancies: </p>
                      <p className="jobPara2">{val.no_of_vacancy}</p>
                    </div>
                    <div className="Details2box">
                      <p className="jobPara1">Employment Type: </p>
                      <p className="jobPara2"> {val.employment_type}</p>
                    </div>
                  </div>
                  {val.job_description ? (
                    <div className="jobDescDiv">
                      <h2>Job Description:</h2>
                      {val.job_description.split("\n").map((x) => {
                        return <p>{x}</p>;
                      })}
                    </div>
                  ) : null}
                  {console.log(
                    "Jo Responsibiity--------------------",
                    val.job_responsibility
                  )}
                  {val.job_responsibility &&
                    val.job_responsibility != null &&
                    val.job_responsibility != "" ? (
                    <div className="jobDescDiv">
                      <h2>Job Responsibilities:</h2>
                      {val.job_responsibility?.split("\n").map((x) => {
                        return <p>{x}</p>;
                      })}
                    </div>
                  ) : null}
                  {val.job_skills &&
                    val.job_skills != null &&
                    val.job_skills != "" ? (
                    <div className="jobDescDiv ">
                      <h2>Skills Required:</h2>
                      <div className="carreersJobSkills">
                        {val.job_skills?.split(",").map((x) => {
                          return (
                            <span className="carreerSkillsBox">{x}</span>
                          );
                        })}
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
              {viewMore.includes(index) ? (
                <button
                  onClick={() => {
                    handleViewLess(index);
                  }}
                  className="careerViewMoreLessBtn viewMoreLessTiggleCareer"
                >
                  View Less
                </button>
              ) : (
                <button
                  onClick={() => {
                    handleViewMore(index);
                  }}
                  className="careerViewMoreLessBtn viewMoreLessTiggleCareer"
                >
                  View More
                </button>
              )}
            </div>
          </div>
        ))}

      <div className="careerPagination">
        {CareerpaginationData.count > 3 ? (
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            onPageChange={handlePageClick}
            // pageRangeDisplayed={3}
            pageCount={Math.ceil(
              CareerpaginationData.count / CareerpaginationData.page_size
            )}
            renderOnZeroPageCount={null}
            activeClassName={"pageActive"}
            pageRangeDisplayed={2}
            // containerClassName={"paginationList"}
            containerClassName={"flex"}
            pageClassName={"paginationList"}
            pageLinkClassName={"pagelinkTag"}
            nextLabelClass={"previous"}
            previousClassName={"previousClass"}
            nextClassName={"previousClass"}
          />
        ) : null}
      </div>
      <ScrolltoTop />
      <div className="footer">
        <Footer />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  careerData: state?.getCareerDataReducer,
  careerjobPostingList: state?.getJobPostingCareerData?.jobPostingList
});

const mapDispatchToProps = (dispatch) => {
  return {
    getCareerData: () => {
      dispatch(getCareerData());
    },
    getJobPostingCareerData: () => {
      dispatch(getJobPostingCareerData());
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Career)),
};
